/**
 * The trainer's stored public form, as `queryOptions`, and the prefix every public-form read sits
 * under.
 *
 * Here rather than in the builder page because two pages write what it caches: the builder's save,
 * and `/raporty`'s editor saving the same LeadForm template (public-form R4). A page may not import
 * another page, so the key both of them invalidate lives one layer down.
 */

import { queryOptions } from '@tanstack/react-query';

import { getPublicForms } from '~/shared/api/generated/endpoints/public-forms/public-forms';

export const publicFormRoot = ['public-form'] as const;
export const publicFormsQueryKey = [...publicFormRoot, 'forms'] as const;

/** The trainer's forms — one at most in this release (R7). */
export function publicFormsQueryOptions() {
  return queryOptions({
    queryKey: publicFormsQueryKey,
    queryFn: ({ signal }) => getPublicForms(undefined, signal),
  });
}
